<template>
	<div v-parallax-fit="parallax" class="hand" ref="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/24_Check_Hand02@2x.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';
export default {
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/ozzie/5.srt',
				'es': '/themes/rise-theme/resources/assets/audio/ozzie/5_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 22400,
					end: 33000,
					fromStyle: { transform: 'translateX(500%) translateY(0%) rotate(0deg)' },
					toStyle: { transform: 'translateX(0%) translateY(0%) rotate(0deg)' },
					easing: 'linear'
				},
				{
					start: 33000,
					end: 34000,
					fromStyle: { transform: 'translateX(0%) translateY(0%) rotate(0deg)' },
					toStyle: { transform: 'translateX(-14%) translateY(25%) rotate(15deg)' },
					easing: 'linear'
				},
				{
					start: 34000,
					end: 38000,
					fromStyle: { transform: 'translateX(-14%) translateY(0%) rotate(0deg)' },
					toStyle: { transform: 'translateX(500%) translateY(0%) rotate(5deg)' },
					easing: 'linear'
				}
			]
		}
	},
	mounted() {
		const audio = '/themes/rise-theme/resources/assets/audio/ozzie/OZZIE_PART6_7_010723.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/7.png',
					url: 'https://www.nlihc.org/sites/default/files/Gentrification_Induced_Displacement-in_Detroit_Michigan-An-Analysis_of_Evictions.pdf',
					link_title: {
						'en': "Gentrification-Induced Displacement in Detroit, Michigan: An Analysis of Evictions",
						'es': 'Desplazamiento inducido por la gentrificación en Detroit, Michigan: un análisis de los desalojos'
					},
				}
			],
			text: ''
		};

		const text = {
			'en': "The design of the auction usually favors wealthy investors with cash on hand, leading to widspread displacement of Detroit residents. The city of Detroit has attempted to implement programs to allow homeowners who experience forclosure the opportunity to buy back their homes from developers. However, the buy back price is often much higher than the property taxes that were originally owed.",
			'es': 'El diseño de la subasta suele favorecer a los inversores adinerados con dinero en efectivo, lo que provoca un desplazamiento generalizado de los residentes de Detroit. La ciudad de Detroit ha intentado implementar programas para permitir que los propietarios de viviendas que experimenten ejecuciones hipotecarias tengan la oportunidad de volver a comprar sus viviendas a los desarrolladores. Sin embargo, el precio de recompra suele ser mucho más alto que los impuestos sobre la propiedad que se debían originalmente.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(0%) translateY(0%) rotate(0deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					this.$evidence.value = JSON.stringify(evidence);
					this.$readMore.value = text;
				}
			});
		});

		this.mutationObserver.observe(this.$refs.hand, {
			attributes: true,
			attributeFilter: ['style']
		});

	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
}
</script>

<style lang="scss" scoped>
.hand {
	position: absolute;
	top: 60px;
	left: 100%;
	min-width: 700px;
	margin-top: 180px;
	margin-left: -100px;
	transition: all 0.1s linear;
}

@media screen and (max-width: 991px) {
	.hand {
		min-width: 500px;
		margin-top: 157px;
		margin-left: -100px;
	}
}

@media screen and (max-width: 650px) {
	.hand {
		min-width: 300px;
		margin-top: 134px;
		margin-left: -100px;
	}
}
</style>
